import { render, staticRenderFns } from "./StoryBoardMain.vue?vue&type=template&id=86b52d06&scoped=true"
import script from "./StoryBoardMain.vue?vue&type=script&lang=js"
export * from "./StoryBoardMain.vue?vue&type=script&lang=js"
import style0 from "./StoryBoardMain.vue?vue&type=style&index=0&id=86b52d06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b52d06",
  null
  
)

export default component.exports